var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 11,
    viewBox: "0 0 48 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.412109,
    y: 0.319336,
    width: 46.7257,
    height: 10.13,
    rx: 5.065,
    fill: "#848FAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMobile);
export default __webpack_public_path__ + "static/media/closeMobile.8c76eb35bd59912d3cc6ef85c2e9a797.svg";
export { ForwardRef as ReactComponent };